import React, { useEffect } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./index.css";
import "./sw-registration";

// Composant wrapper pour vérifier l'expiration du JWT
const TokenExpirationChecker = ({ children }) => {
  useEffect(() => {
    // Fonction pour vérifier si le token est expiré
    const checkTokenExpiration = () => {
      const token = localStorage.getItem("token");

      if (!token) return;

      try {
        // Décode le token JWT
        const payload = JSON.parse(
          atob(token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/"))
        );

        // Vérifie si le token est expiré
        const isExpired = payload.exp * 1000 < Date.now();

        if (isExpired) {
          // Si expiré, déconnecte l'utilisateur
          localStorage.removeItem("token");
          localStorage.removeItem("isAdmin");

          // Si l'utilisateur n'est pas sur la page de connexion, affiche un message et redirige
          if (window.location.pathname !== "/login") {
            toast.error(
              "Votre session a expiré. Vous allez être redirigé vers la page de connexion."
            );
            // Petit délai pour permettre à l'utilisateur de voir le message
            setTimeout(() => {
              window.location.href = "/login";
            }, 2000);
          }
        }
      } catch (error) {
        console.error("Erreur lors de la vérification du token:", error);
      }
    };

    // Vérifie immédiatement
    checkTokenExpiration();

    // Vérifie toutes les minutes
    const intervalId = setInterval(checkTokenExpiration, 60000);

    // Ajoute un écouteur pour les changements d'état de l'application (focus)
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        checkTokenExpiration();
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    // Écoute les changements dans localStorage
    const handleStorageChange = (e) => {
      if (e.key === "token" || e.key === null) {
        checkTokenExpiration();
      }
    };
    window.addEventListener("storage", handleStorageChange);

    // Nettoyage à la destruction du composant
    return () => {
      clearInterval(intervalId);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  return children;
};

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <TokenExpirationChecker>
    <App />
    <ToastContainer
      position="top-center"
      autoClose={3000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
    />
  </TokenExpirationChecker>
);

/*
# Utilisation de React-Toastify dans vos composants :

import { toast } from "react-toastify";

toast.success("Message de succès !");
toast.error("Message d'erreur !");
toast.warning("Message d'avertissement !");
toast.info("Message d'information !");
*/
